<template>
    <div>
        <card-header title='New Registration Discount' icon="fa-plus"/>

        <card-body>
            <rmc-discount-form :discount="newDiscount"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!newDiscount.code || !newDiscount.title || !newDiscount.type || !newDiscount.value"
                    ><i class="fas fa-plus mr-2"></i>New Registration Discount</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import RmcFeeForm from "./FeeForm";

    import {client as http} from "@/http_client";
    import RmcDiscountForm from "./DiscountForm";

    export default {
        components: {RmcDiscountForm, RmcFeeForm, CardHeader, CardToolbar, CardBody, CardFooter},
        props: ['card', 'props'],
        data() {
            return {
                newDiscount: {}
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                http.post('rmc/discounts', this.newDiscount, {force: true}).then(response => {
                    this.$reloadCard('rmc-discounts', {confId: this.props.confId});
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the conference fee.');
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.newDiscount.conference_id = this.props.confId
        }
    }
</script>
